module.exports = ".flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n\n.width-left-one {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/filters/contributor-filter/contributor-filter.component.css
// module id = ./src/app/helpers/filters/contributor-filter/contributor-filter.component.css
// module chunks = main